import { TokenLogout } from "API/Logout/logout";
import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL
const Bankurl = process.env.REACT_APP_BANKVERIFY_URL
const ifscurl = process.env.REACT_APP_APPROVAL_URL


export const GetCspList = async (filter, page, setIsLoading, setData, handleAlertMessage) => {
    try {
        setIsLoading(true);
        await axios.post(`${url}/csp_list/agents`, {
            page: page,
            filters: { [filter.category]: filter.value, "status": filter.status }
        }, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            },

        })
            .then((response) => {
                setIsLoading(false);
                setData(response);
            })
    }
    catch (error) {
        setIsLoading(false)
        handleAlertMessage(error && error.response && error.response.data.error ? error.response.data.error : "Couldn't able to load data", "error");
        TokenLogout(error);
    }
}

export const UpdateData = async (postData, setIsLoading, handleAlertOpen, userId, GetData, handleClose) => {
    try {
        await axios.put(`${url}/csp_list/agent_update/${userId}`, postData, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                setIsLoading(false);
                handleAlertOpen(response.data.message, "success");
                GetData()
                setTimeout(() => {
                    handleClose()
                }, 1500)
            })
    }
    catch (error) {
        console.log(error);
        setIsLoading(false)
        handleAlertOpen(error && error.response && error.response.data.error ? error.response.data.error : "Couldn't able to update data", "error");
        TokenLogout(error);
    }
}

export const DynamicGet = async (field, setValue) => {
    setValue(null)
    try {
        const res = await axios.get(field.field_details.url)
        const data = res.data
        setValue(data)
    } catch (err) {
        console.log(err)
    }

}

export const getDynamicDataWithParams = async (field, params, setValue) => {
    console.log(field);
    console.log("params ", params);
    // console.log();

    try {
        const res = await axios.get(field.field_details.url, {
            params: params
        })
        const data = res.data
        setValue(data)
    } catch (err) {
        console.log(err)
    }
}

export const PostDynamicData = async (field, setValue) => {
    console.log(field);
    // console.log("params ", params);
    // console.log();

    try {
        const res = await axios.post(field.field_details.url, {

        }, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            }
        })

        const data = res.data
        setValue(data)
    } catch (err) {
        console.log(err)
    }
}

export const DynamicVerifyBank_Request_id = async (
    account_number,
    ifsc_code,
    name,
    bankusername,
    handleAlertOpen,
    setIsLoading,
    setModifiedUserData,
    ifsc_key,
    instance,
    ModifiedUserData,
    setVerificationStatus
) => {
    const request_id = sessionStorage.getItem('request_id');
    let retry = instance;
    try {
        setIsLoading(true);
        await axios
            .post(
                `${Bankurl}/idfy-bank-verification/bank/task_details`,
                { request_id },
                {
                    headers: {
                        Authorization: `${sessionStorage.getItem('UserToken')}`
                    }
                }
            )
            .then((res) => {
                setIsLoading(false);
                if (res.data.details.result.status === 'id_found') {
                    const bankName = res.data.details.result.name_at_bank
                        .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
                        .toLowerCase().trim()
                    // .replace(/\s+/g, '');
                    // const aadhaarName = sessionStorage.getItem('aadhaar_name')?.toLowerCase().trim();
                    // const bankWords = bankName.split(' ');
                    // const aadhaarWords = aadhaarName.split(' ');

                    // const bankFirstName = bankWords[0];
                    // const bankLastName = bankWords[bankWords.length - 1];

                    // const aadhaarFirstName = aadhaarWords[0];
                    // const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

                    // const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
                    // if (!ValidateName) {
                    // handleAlertOpen('The name does not match the name on your bank account.',"error");
                    // } else if (ValidateName) {

                    if (res.data.details.result.status === 'id_not_found') {
                        handleAlertOpen('Account number does not match the selected bank. Please re-enter the correct account number', "error");
                    } else if (res.data.details.result.status === 'ind_vpa') {
                        handleAlertOpen('Upi id is invalid', "error");
                    }
                    else {

                        sessionStorage.setItem('bank_ifsc', ifsc_code);

                        handleAlertOpen('Account Verified Successfully', "success");
                        sessionStorage.setItem(bankusername, bankName);
                        sessionStorage.setItem('bankusername', bankName);
                        sessionStorage.setItem(`${name}_verify`, true);
                        setVerificationStatus(prev => ({ ...prev, isVerified: true }));
                        setModifiedUserData({ ...ModifiedUserData, [bankusername]: bankName })
                        setTimeout(() => {
                            sessionStorage.setItem(name, account_number);
                            sessionStorage.setItem(ifsc_key, ifsc_code);
                        }, 1000);
                    }
                }
            })
            .catch((error) => {
                TokenLogout(error)
                if (retry < 4) {
                    setTimeout(() => {
                        DynamicVerifyBank_Request_id(
                            account_number,
                            ifsc_code,
                            name,
                            bankusername,
                            handleAlertOpen,
                            setIsLoading,
                            setModifiedUserData,
                            ifsc_key,
                            retry + 1,
                            ModifiedUserData,
                            setVerificationStatus
                        );
                    }, 2000);
                } else {
                    console.log("denoou", error);
                    setIsLoading(false);
                    handleAlertOpen(error.response && error.response.data.message ? error.response.data.message : error.response.data.error ? error.response.data.error : 'Unable to verify your account number', "error");
                }
            })
    } catch (error) {
        TokenLogout(error)
        if (retry < 4) {
            setTimeout(() => {
                DynamicVerifyBank_Request_id(
                    account_number,
                    ifsc_code,
                    name,
                    bankusername,
                    handleAlertOpen,
                    setIsLoading,
                    setModifiedUserData,
                    ifsc_key,
                    retry + 1,
                    ModifiedUserData,
                    setVerificationStatus
                );
            }, 2000);
        } else {
            console.log("denoou", error);
            setIsLoading(false);
            handleAlertOpen(error.response && error.response.data && error.response.data.message ? error.response.data.message : error.response.data.error ? error.response.data.error : 'Unable to verify your account number', "error");
        }
    }
};

export const GetBankIfscDetails = async (productId, setData) => {
    try {
        await axios.post(`${ifscurl}/fi_banks`, { product_id: productId }, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
            .then((res) => {
                setData(res.data)
            })
    }
    catch (error) {
        console.log(error)
        console.clear()

    }
}


export const CheckActiveApi = async (setIsLoading, handleAlertOpen) => {
    try {
        setIsLoading(true);
        const res = await axios.get(`${Bankurl}/aadhar-idfy/get_service_vendor`);
        setIsLoading(false);
        // console.log(res);
        return res; // Return the full response (or res.data if only that is needed)
    } catch (error) {
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        // throw error; // Optional: rethrow to handle in caller
    }
};


export const DynamicVerifyBank_Request_id_Bharat = async (
    res,
    account_number,
    ifsc_code,
    name,
    bankusername,
    handleAlertOpen,
    setIsLoading,
    setModifiedUserData,
    ifsc_key,
    ModifiedUserData,
    setVerificationStatus

) => {
    // const request_id = sessionStorage.getItem('request_id');
    try {
        setIsLoading(true);
        await axios
            .post(
                `${Bankurl}/aadhar-idfy/bank-account/get-status`,
                {
                    request_id: res.data.request_id,
                    result_id: res.data.result_id
                },
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
                    }
                }
            )
            .then((res) => {
                setIsLoading(false);
                if (res.data?.status === "SUCCESS") {
                    const bankName = res.data?.beneficiary_name
                        .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
                        .toLowerCase().trim()
                    handleAlertOpen('Account Verified Successfully', "success");
                    sessionStorage.setItem(bankusername, bankName);
                    sessionStorage.setItem('bankusername', bankName);
                    sessionStorage.setItem(`${name}_verify`, true);
                    setVerificationStatus(prev => ({ ...prev, isVerified: true }));
                    setModifiedUserData({ ...ModifiedUserData, [bankusername]: bankName })
                    setTimeout(() => {
                        sessionStorage.setItem(name, account_number);
                        sessionStorage.setItem(ifsc_key, ifsc_code);
                    }, 1000);


                } else {
                    handleAlertOpen('Unable to verify account number', "error");
                }
            })
            .catch((error) => {
                TokenExpires(error)

                console.log("error", error);
                setIsLoading(false);
                handleAlertOpen(error.response.data.message ? error.response.data.message : error.response.data.error ? error.response.data.error : 'Unable to verify your account number', "error");

            })
    } catch (error) {
        TokenExpires(error)

        // console.log("denoou",error);
        setIsLoading(false);
        setErrMessage(error.response.data.message ? error.response.data.message : error.response.data.error ? error.response.data.error : 'Unable to verify your account number');
        setAlertOpen(true);

    }
    finally {
        setIsLoading(false);
    }
};


export const DynamicBankVerifyBharat = async (
    ifsc_code,
    account_number,
    name,
    bankusername,
    handleAlertOpen,
    setIsLoading,
    setModifiedUserData,
    ifsc_key,
    ModifiedUserData,
    setVerificationStatus
) => {
    try {
        await axios.post(`${Bankurl}/aadhar-idfy/bank-account/send-request`, {
            ifsc: ifsc_code,
            account_number: account_number,
        }, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
            .then((res) => {
                if (res.data && res.data.status === "SUCCESS") {
                    const bankName = res.data?.beneficiary_name
                        .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
                        .toLowerCase().trim()
                    handleAlertOpen('Account Verified Successfully', "success");
                    sessionStorage.setItem(bankusername, bankName);
                    sessionStorage.setItem('bankusername', bankName);
                    sessionStorage.setItem(`${name}_verify`, true);
                    setVerificationStatus(prev => ({ ...prev, isVerified: true }));
                    setModifiedUserData({ ...ModifiedUserData, [bankusername]: bankName })
                    setTimeout(() => {
                        sessionStorage.setItem(name, account_number);
                        sessionStorage.setItem(ifsc_key, ifsc_code);
                    }, 1000);

                }
                else {
                    DynamicVerifyBank_Request_id_Bharat(
                        res,
                        account_number,
                        ifsc_code,
                        name,
                        bankusername,
                        handleAlertOpen,
                        setIsLoading,
                        setModifiedUserData,
                        ifsc_key,
                        ModifiedUserData,
                        setVerificationStatus
                    )
                }
            })
    }
    catch (error) {
        TokenLogout(error)
        handleAlertOpen(error.response && error.response.data && error.response.data.message ? error.response.data.message : error.response.data.error ? error.response.data.error : 'Unable to verify your account number', "error");
    }
    finally {
        setIsLoading(false);
    }
}


export const DynamicBankAccNumberVerify = async (
    ifsc_code,
    account_number,
    name,
    bankusername,
    handleAlertOpen,
    setIsLoading,
    setModifiedUserData,
    ifsc_key,
    ModifiedUserData,
    setVerificationStatus
) => {
    // console.log('ifsc', ifsc_code);
    try {
        setIsLoading(true);
        await axios
            .post(
                `${Bankurl}/idfy-bank-verification/bank/verify_bank`,
                {
                    ifsc_code,
                    account_number,
                    task_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta',
                    group_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta'
                },
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
                    }
                }
            )
            .then((res) => {
                setIsLoading(false);
                const request_id = res.data.details.request_id;
                if (request_id) {
                    sessionStorage.setItem('request_id', request_id);

                    DynamicVerifyBank_Request_id(
                        account_number,
                        ifsc_code,
                        name,
                        bankusername,
                        handleAlertOpen,
                        setIsLoading,
                        setModifiedUserData,
                        ifsc_key,
                        0,
                        ModifiedUserData,
                        setVerificationStatus
                    );
                    // handleClick();
                    sessionStorage.setItem('bank_acc', account_number);
                }
            });
    } catch (error) {
        TokenLogout(error)
        console.log('error', error);
        setIsLoading(false);
        handleAlertOpen(error.response ? error.response.data.error : 'Unable to verify your account number', "error");

    }
};


export const HandleUpdateStatus = async (data, setIsLoading, handleAlertOpen, handleClose, GetList) => {
    try {
        setIsLoading(true);
        await axios.put(`${url}/csp_list/update_backend_status`, data, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                setIsLoading(false);
                handleAlertOpen(response.data.message, "success");
                handleClose()
                GetList()
            })
    }
    catch (error) {
        setIsLoading(false)
        handleAlertOpen(error && error.response && error.response.data.error ? error.response.data.error : "Couldn't able to update data", "error");
        TokenLogout(error);
    }
}


export const HandleUpdateStatusUserList = async (data, setIsLoading, handleAlertOpen, handleClose, GetList) => {
    try {
        setIsLoading(true);
        await axios.put(`${url}/csp_list/update_csp_status`, data, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                setIsLoading(false);
                handleAlertOpen(response.data.message, "success");
                handleClose()
                GetList()
            })
    }
    catch (error) {
        console.log("error", error);
        setIsLoading(false)
        handleAlertOpen(error && error.response && error.response.data.error ? error.response.data.error : "Couldn't able to update data", "error");
        TokenLogout(error);
    }
}